import { render } from "@/share/components/pages/ChangePassword/ChangePassword.html?vue&type=template&id=2fd1de0e&external"
import script from "@/share/components/pages/ChangePassword/ChangePassword.js?vue&type=script&lang=js&external"
export * from "@/share/components/pages/ChangePassword/ChangePassword.js?vue&type=script&lang=js&external"

import "@/share/components/pages/ChangePassword/ChangePassword.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__